var render, staticRenderFns
import script from "./NBtn.vue?vue&type=script&lang=js"
export * from "./NBtn.vue?vue&type=script&lang=js"
import style0 from "./NBtn.vue?vue&type=style&index=0&id=f74dcfb8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports